var AddressEntity = /** @class */ (function () {
    function AddressEntity(args) {
        Object.assign(this, args);
    }
    AddressEntity.prototype.getCityState = function () {
        return [this.city, this.state, this.country].filter(Boolean).join(', ');
    };
    return AddressEntity;
}());
export { AddressEntity };
